import { noop } from "lodash";
import { useStreamHoursAddon } from "@circle-react/components/LiveStreams/hooks";
import { useLiveStreamsConfig } from "./useLiveStreamsConfig";
import { useLiveStreamsUsage } from "./useLiveStreamsUsage";

const SECONDS_IN_HOUR = 3600;

export const useLiveStreamHoursAvailable = (
  { enabled } = { enabled: true },
) => {
  const { config, isLoading: isLoadingConfig } = useLiveStreamsConfig({
    enabled,
  });
  const { usage, isLoading: isLoadingUsage } = useLiveStreamsUsage({ enabled });
  const { currentQuantity: streamHoursAddonQuantity } = useStreamHoursAddon(
    noop,
    { enabled },
  );
  const streamHoursAddonQuantityNumber = Number(streamHoursAddonQuantity || 0);

  const isLoading = isLoadingConfig || isLoadingUsage;

  const streamingUsedSeconds = usage?.stream_duration || 0;
  const streamingPlanValue = Number(
    config?.live_stream_monthly_stream_hours || 0,
  );
  const streamingPlanSeconds = streamingPlanValue * SECONDS_IN_HOUR;
  const streamingAddonsSeconds =
    streamHoursAddonQuantityNumber * SECONDS_IN_HOUR;

  const streamingTotalPlanHours =
    streamingPlanValue + streamHoursAddonQuantityNumber;

  return {
    isLoading,
    streamingHoursAvailable:
      streamingUsedSeconds < streamingPlanSeconds + streamingAddonsSeconds,
    streamingTotalPlanHours,
  };
};
